import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

// TASK 39658
// an effort to eliminate browser caching of html files
// so users do not need to clear browser cache after deployments.
// angular cache busting build configuration (outputHashing) is already set
// and should eliminate browser caching issues for js and css files
@Injectable()
export class NoCacheHTMLInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const authReq = req.clone({
      setHeaders: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache'
      }
    });
    return next.handle(authReq);
  }
}
